import {
  Box,
  Heading,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Divider,
} from '@chakra-ui/react';

const About = () => (
  <Box
    p={6}
    textAlign="center"
    shadow="sectionShadow"
    borderRadius="lg"
    bg="pastelWhite"
    my={6}
  >
    <Heading mb={4} fontSize="2xl" color="pastelGreen">
      About Me
    </Heading>
    <Text fontSize="lg" mb={6} color="gray.700">
      I am a wife, mother, teacher, and passionate Bible student.
    </Text>
    <Accordion allowToggle>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box flex="1" textAlign="left">
              My Family
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel>
          Married for over 30 years to Jeff and mother to two amazing children.
        </AccordionPanel>
      </AccordionItem>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box flex="1" textAlign="left">
              My Mission
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel>
          Passionate about teaching the Bible and helping women discover joy in Scripture.
        </AccordionPanel>
      </AccordionItem>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Box flex="1" textAlign="left">
              My Interests
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel>
          Gathering with loved ones, learning, and helping others find hope in Jesus.
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
    <Divider my={6} />
    <Text fontSize="lg" mt={4} color="gray.700">
      Discovering, learning, and sharing God’s truths with others is my greatest joy.
    </Text>
  </Box>
);

export default About;
